import Vue from "vue";
import VueRouter from "vue-router";

// Landing Page
import Home from "@/views/Home.vue";
import About from "@/views/About.vue";
import Adopt from "@/views/Adopt.vue";
import Family from "@/views/Family.vue";
import Loading from "@/views/Loading.vue";
import Products from "@/views/Products.vue";

import Email from "@/views/Email.vue";
import SearchPet from "@/views/pets/SearchPet.vue";

// Auth
import Login from "@/views/auth/Login.vue";
import Recovery from "@/views/auth/Recovery.vue";

// Pets
import Pet from "@/views/pets/Pet.vue";
import Pets from "@/views/pets/Pets.vue";

// Appointments
import Appointment from "@/views/appointments/Appointment.vue";
import Appointments from "@/views/appointments/Appointments.vue";

// Users
import User from "@/views/users/User.vue";
import Users from "@/views/users/Users.vue";

// Vaccinations
import Vaccination from "@/views/vaccinations/Vaccination.vue";
import Vaccinations from "@/views/vaccinations/Vaccinations.vue";

// Medical Histories
import MedicalHistory from "@/views/medical_histories/MedicalHistory.vue";
import MedicalHistories from "@/views/medical_histories/MedicalHistories.vue";

// Stocks
import Stock from "@/views/stock/Stock.vue";
import Stocks from "@/views/stock/Stocks.vue";

// Inventories
import Inventory from "@/views/inventories/Inventory.vue";
import Inventories from "@/views/inventories/Inventories.vue";

// Providers
import Provider from "@/views/providers/Provider.vue";
import Providers from "@/views/providers/Providers.vue";

// Species
import Specie from "@/views/species/Specie.vue";
import Species from "@/views/species/Species.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Loading
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   component: About
  // },
  // {
  //   path: "/products",
  //   name: "Products",
  //   component: Products
  // },
  // {
  //   path: "/adopt",
  //   name: "Adopt",
  //   component: Adopt
  // },
  // {
  //   path: "/family",
  //   name: "Family",
  //   component: Family
  // },
  {
    path: "/search_pet",
    name: "SearchPet",
    component: SearchPet
  },
  {
    path: "/email",
    name: "Email",
    component: Email
  },
  {
    path: "/auth/login",
    name: "Login",
    component: Login
  },
  {
    path: "/auth/recovery_password/:token",
    name: "Recovery",
    component: Recovery
  },
  {
    path: "/pets",
    name: "Pets",
    component: Pets
  },
  {
    path: "/pets/:id",
    name: "Pet",
    component: Pet
  },
  {
    path: "/appointments",
    name: "Appointments",
    component: Appointments
  },
  {
    path: "/appointments/:id",
    name: "Appointment",
    component: Appointment
  },
  {
    path: "/users",
    name: "Users",
    component: Users
  },
  {
    path: "/users/:username",
    name: "User",
    component: User
  },
  {
    path: "/vaccinations",
    name: "Vaccinations",
    component: Vaccinations
  },
  {
    path: "/vaccinations/:id",
    name: "Vaccination",
    component: Vaccination
  },
  {
    path: "/stock",
    name: "Stocks",
    component: Stocks
  },
  {
    path: "/stock/:id",
    name: "Stock",
    component: Stock
  },
  {
    path: "/inventories",
    name: "Inventories",
    component: Inventories
  },
  {
    path: "/inventories/:id",
    name: "Inventory",
    component: Inventory
  },
  {
    path: "/providers",
    name: "Providers",
    component: Providers
  },
  {
    path: "/providers/:id",
    name: "Provider",
    component: Provider
  },
  {
    path: "/medical_histories",
    name: "MedicalHistories",
    component: MedicalHistories
  },
  {
    path: "/medical_histories/:id",
    name: "MedicalHistory",
    component: MedicalHistory
  },
  {
    path: "/species",
    name: "Species",
    component: Species
  },
  {
    path: "/species/:id",
    name: "Specie",
    component: Specie
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
